import React, { useEffect, useState } from "react";
import { useApi } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function Templates() {
  const { get } = useApi();
  const [items, setItems] = useState([]);

  useEffect(() => {
    get("/templates").then(r => setItems(r.data));
  }, []); // eslint-disable-line

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-slate-500">Library</p>
        <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1">
          Outreach Templates
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Owner-approved templates with state-specific disclosures and merge fields.
          The AI assistant can also draft messages on top of these.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 cw-stagger">
        {items.map((t) => (
          <Card key={t.id} className="p-4 border-slate-200" data-testid={`template-${t.id}`}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <h3 className="font-display text-lg font-bold text-slate-900">{t.name}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <Badge variant="outline" className="text-xs">{t.channel.toUpperCase()}</Badge>
                  {t.touchpoint && <Badge variant="outline" className="text-xs bg-slate-100">Touchpoint #{t.touchpoint}</Badge>}
                  {t.state && <Badge variant="outline" className="text-xs">{t.state}</Badge>}
                </div>
              </div>
            </div>
            {t.subject && (
              <p className="text-xs font-semibold text-slate-700 mt-2">
                <span className="uppercase tracking-widest text-slate-400 mr-2">Subject:</span>{t.subject}
              </p>
            )}
            <div className="mt-3 p-3 bg-slate-50 border border-slate-200 rounded text-xs text-slate-700 max-h-48 overflow-auto whitespace-pre-wrap font-mono">
              {t.body}
            </div>
            {t.required_disclosures?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1">
                {t.required_disclosures.map((d) => (
                  <Badge key={d} variant="outline" className="text-[10px] bg-emerald-50 text-emerald-700 border-emerald-200">
                    {d.replace(/_/g, " ")}
                  </Badge>
                ))}
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}
